import { render, staticRenderFns } from "./VendorsCommodity.vue?vue&type=template&id=4fb142b8&"
import script from "./VendorsCommodity.vue?vue&type=script&lang=js&"
export * from "./VendorsCommodity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports